module.exports = __webpack_public_path__ + "assets/21a8f26ff4d364e744912f3f40de3cf3.mp3";